import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import * as loginSelectors from './../../../../../root-store/login-store/login.selector';
import { Store } from '@ngrx/store';
import { DocumentService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'collection-reminder',
  templateUrl: './collection-reminder.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionReminderComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() dCollectionRemainderEmitter = new EventEmitter<any>();

  currentUser;
  gatherOriginedReminders;
  subscription = new Subscription();

  constructor(private store: Store, private documentService: DocumentService, private toastr: ToastrService, private cd: ChangeDetectorRef) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.currentUser = user;
      })
    );
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.gatherOriginedReminders = [];
      this.getVaultUserFormReminder();
    }
  }

  getVaultUserFormReminder() {
    this.subscription.add(
      this.documentService.getReminderList(this.data?.user_id, this.data?.vault_user_form_id, true).subscribe(
        (res) => {
          this.gatherOriginedReminders = res.filter((x) => x.origin == 'gather');
          this.cd.detectChanges();
        },
        (error) => {}
      )
    );
  }

  markReminderCompleteOrNotNeeded(id, type) {
    const payload = {
      id: id,
      // user_id: this.data?.user_id,
      vault_user_form_id: this.data?.vault_user_form_id,
      ...(type == 'complete' && { status: 'complete', is_active: true }),
      ...(type == 'notneeded' && { status: 'notstarted', is_active: false }),
    };
    this.subscription.add(
      this.documentService.updateReminder(payload).subscribe(
        (res) => {
          let updatedRemainder = this.gatherOriginedReminders.filter((remainder) => {
            return remainder.id == res.data.id;
          });
          updatedRemainder[0].status = res.data.status;
          updatedRemainder[0].is_active = res.data.is_active;
          // this.toastr.success(`Reminder Marked As ` + res.data?.status + ` Successfully.`);
          this.cd.detectChanges();
        },
        (error) => {
          this.toastr.error(error);
        }
      )
    );
  }

  handleSteps(event) {
    this.dCollectionRemainderEmitter.emit({ status: event, id: this.data?.id });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
